import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';

import { hasPermission } from '@/entities/practice-member';

type CalendarBeforeLoadArgs = {
    context: { queryClient: QueryClient };
};

export async function calendarBeforeLoad({ context }: CalendarBeforeLoadArgs) {
    if (!(await hasPermission(context.queryClient, ['CLINICIAN', 'EHR_BASE']))) {
        throw notFound();
    }
}
